export type ServicingParams = {
  id: string
  dealName: string
  facilityName: string
  stage: string
  transaction: string
  amount: number
  currency: string
  admin: string | string[]
  notices: string
  effectiveDate: string | Date
  scheduled: string
  type: ServicingTypes
  original?: null | any
  // Identifiers used by CSV export only — not displayed in the in-app table.
  dealId?: string
  facilityId?: string
  clientFacilityId?: string | null
  facilityCusip?: string | null
  facilityLxId?: string | null
  /** Lifecycle state of the row's facility ('' when unknown); drives row-click navigation. */
  facilityStatus?: string
  /** effectiveDate equals the business date the feed was built for. */
  isToday?: boolean
  /** `pikOption` of the row's facility (null when unknown); gates "Process PIK" in the loan menu. */
  facilityPikOption?: string | null
  /** A Fee row until GET /api/servicing/fee-amounts prices it: `amount` is unknown (0 in the data) meanwhile. */
  amountPending?: boolean
  /** A Fee row the ledger could not price: `amount` stays unknown; the row is kept, not removed. */
  amountUnavailable?: boolean
}

export enum ServicingTypes {
  loanConversion = 'loanConversion',
  loanMerge = 'loanMerge',
  amortizationSchedule = 'amortizationSchedule',
  maturingLoan = 'maturingLoan',
  maturingDeal = 'maturingDeal',
  maturingFacility = 'maturingFacility',
  loanRollover = 'loanrollover',
  loanRolloverSplit = 'loanRolloverSplit',
  loanIncrease = 'loanincrease',
  loanRateSetting = 'loanratesetting',
  principalPayment = 'principalPayment',
  loanAddRates = 'loanAddRates',
  newBorrowing = 'newBorrowing',
  pik = 'PIK',
  feePayment = 'feepayment',
  fee = 'fee',
  pikScheduleLoan = 'pikScheduleLoan',
  facilityReverse = 'facilityReverse',
}
